export default {
  state: {
    showRemindTopList: [],     // 置顶提醒数组
    showRemindTop: false,     // 是否展示我的置顶提醒
    effectiveType: 'Good',    // 网络状态
    TIMIsLoginOut: false,  // IM是否被挤下线
    TIMExamId: '',       // 接收到的im消息属于哪个考试  
    createTim: 0,
    aiCheckPos: null,    // ai检测结果
    aiJudgeResult: null,    // ai批改结果
    revocationMessage: null,   // 撤回消息
    screenAlert: false,       // 是否弹出屏幕分享框
    examId: '',          // 当前进行屏幕分享的考试id
    shareClient: '',    // 屏幕分享客户端
    shareStream: '',     // 屏幕分享流
    shareStreamTips: false,     // 屏幕分享中断提示
    tim: '',                // tim用户
    TIMMessage: {},           // 用于接收h5端是否推流的IM数据
    TIMChatRecord: [],       // im聊天消息
    faceTipDesc: '',         // 人脸识别消息
    trimerScreenStore: null,  // 屏幕分享定时器
    examConfig: null,           // 管理后台修改的考试配置
    verificationOfIdentity: null,   // 身份核验--系统核验结果
    omsTips: null,            // 管理端发来的提醒消息
    saveWritingTime: 0,       // 写作保存的次数
    openAllDiag: false,         // 全屏弹框是否关闭
    reconnectObj: null,      // 后台重新呼起学生推流
    beginRadio: false         // 监考端是否开始广播
  },
  mutations: {
    set_aiJudgeResult (state, val) {
      state.aiJudgeResult = val
    },
    set_showRemindTop (state, val) {
      state.showRemindTop = val
    },
    set_showRemindTopList (state, val) {
      state.showRemindTopList = val
    },
    set_effectiveType (state, val) {
      state.effectiveType = val
    },
    set_reconnectObj (state, val) {
      state.reconnectObj = val
    },
    set_aiCheckPos (state, val) {
      state.aiCheckPos = val
    },
    set_TIMIsLoginOut (state, val) {
      state.TIMIsLoginOut = val
    },
    set_revocationMessage (state, val) {
      state.revocationMessage = val
    },
    set_shareClient (state, val) {
      state.shareClient = val
    },
    set_createTim (state, val) {
      state.createTim = val
    },
    set_shareStream (state, val) {
      state.shareStream = val
    },
    set_shareStreamTips (state, val) {
      state.shareStreamTips = val
    },
    set_tim (state, val) {
      state.tim = val
    },
    set_TIMMessage (state, val) {
      state.TIMMessage = val
    },
    set_examId (state, val) {
      state.examId = val
    },
    set_TIMExamId (state, val) {
      state.TIMExamId = val
    },
    set_screenAlert (state, val) {
      state.screenAlert = val
    },
    set_TIMChatRecord (state, val) {
      state.TIMChatRecord = val
    },
    set_faceTipDesc (state, val) {
      state.faceTipDesc = val
    },
    set_trimerScreenStore (state, val) {
      state.trimerScreenStore = val
    },
    set_examConfig (state, val) {
      state.examConfig = val
    },
    set_verificationOfIdentity (state, val) {
      state.verificationOfIdentity = val
    },
    set_omsTips (state, val) {
      state.omsTips = val
    },
    set_saveWritingTime (state, val) {
      state.saveWritingTime = val
    },
    set_openAllDiag (state, val) {
      state.openAllDiag = val
    },
    set_beginRadio (state, val) {
      state.beginRadio = val
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/test.js